export default [
    {
        path: `/tags/view/:tagId`,
        component: () => import('@/pages/tags/index.vue')
    }
]
